/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CBRRoutePlanCreateMutation($input: [CBRRoutePlanCreateInput!]!) {
  CBRRoutePlanCreate(input: $input) {
    id,
    message,
    status
  }
}
`
